var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1728243653748,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4245,
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024c-283.136 0-512-228.928-512-512 0-283.136 228.864-512 512-512 283.072 0 512 228.864 512 512 0 283.072-228.928 512-512 512zM512 102.4A409.472 409.472 0 0 0 102.4 512c0 226.304 183.296 409.6 409.6 409.6 226.304 0 409.6-183.296 409.6-409.6 0-226.304-183.296-409.6-409.6-409.6z m283.968 320.96l-303.744 303.744a52.48 52.48 0 0 1-73.152 0l-182.464-182.4a52.48 52.48 0 0 1 0-73.152 52.48 52.48 0 0 1 73.152 0l146.304 146.304 267.584-267.648a52.48 52.48 0 0 1 73.152 0c19.84 19.776 19.84 52.48-0.832 73.152z",
    fill: "#2FC25B",
    "p-id": 4246
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b576d881a9a1c90a11af6f598ee358b0.svg";
export { ForwardRef as ReactComponent };